import { Component, OnInit } from '@angular/core';
// import { WOW } from 'wowjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.html',
  styleUrl: './home.scss',
  imports: [CommonModule]
})
export class Home implements OnInit {
  slides = [
    {
      title: `Since 2019, we have been helping our clients release better <span class="title-break">software products and have improved the quality of legacy platforms.</span>`,
      subtitle: 'We can guarantee quality service.',
      rowClass: '',
      colClass: 'col-12 hero-slide-content',
    },
    {
      title: `A one-stop shop for all your software development needs`,
      subtitle: 'On-site, off-site, offshore… whatever works best for you.',
      rowClass: '',
      colClass: 'col-12 hero-slide-content',
    },
    {
      title: `<span class="text-nowrap">Custom Software Applications &</span> <br> Platforms to meet your specific needs`,
      subtitle: 'We can guarantee that our service will be cheaper and faster than a "Buy and Customize" option…',
      rowClass: 'service-banner-container service-banner-carousel',
      colClass: 'col-md-7 order-mobile-2',
      img: '/assets/images/services/sw-team.png',
      imgColClass: 'col-md-5 order-mobile-1 text-center',
      imgAlt: '',
    },
    {
      title: 'Qualibar provides a breadth of services…',
      subtitle: 'We have significant expertise in M&A Technology Advisory and Staff Augmentation.',
      rowClass: 'service-banner-container service-banner-carousel',
      colClass: 'col-md-7 order-mobile-2',
      img: '/assets/images/services/softwate-development.svg',
      imgColClass: 'col-md-5 order-mobile-1 text-center',
      imgAlt: '',
    },
    {
      title: `Advanced Search Engine Optimization (SEO)<span class="d-block">& Social Media Marketing (SMM) Services</span>`,
      subtitle: 'We are a trusted Google Partner.',
      rowClass: 'service-banner-container service-banner-carousel',
      colClass: 'col-md-8 order-mobile-2',
      img: '/assets/images/services/banner-seo1-img.svg',
      imgColClass: 'col-md-4 order-mobile-1 text-center',
      imgAlt: '',
      imgStyle: 'transform: scale(1.5)'
    }
  ];

  activeSlide = 0;
  slideInterval: any;

  ngOnInit() {
    if (typeof window !== 'undefined') {
      import('wowjs').then(({ WOW }) => {
        new WOW().init();
      });
    }
    this.startAutoSlide();
  }

  startAutoSlide() {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 15000);
  }

  stopAutoSlide() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  prevSlide() {
    this.stopAutoSlide();
    this.activeSlide = (this.activeSlide - 1 + this.slides.length) % this.slides.length;
    this.startAutoSlide();
  }

  nextSlide() {
    this.stopAutoSlide();
    this.activeSlide = (this.activeSlide + 1) % this.slides.length;
    this.startAutoSlide();
  }
}
